var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AeButton',{staticClass:"button-add-fixed",class:{ mobile: _vm.$globals.ENV_MOBILE_DEVICE },attrs:{"fill":"primary","to":_vm.to},on:{"click":function($event){return _vm.$emit('click')}}},[_c('Plus')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }